import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence, LayoutGroup } from 'framer-motion';
import ScrollReveal from './ScrollReveal';
import '../styles/ServicesSection.css';

const services = [
  { id: 1, title: 'Web Design', image: '/assets/images/website-dev.png' },
  { id: 2, title: 'SEO Optimization', image: '/assets/images/SEO-optimizing.jpg' },
  { id: 3, title: 'Social Media Management', image: '/assets/images/Socialmedia-editing.jpg' },
  { id: 4, title: 'Facebook Marketing', image: '/assets/images/facebook-marketing.png' },
];

const ServicesSection = () => {
  const [selectedService, setSelectedService] = useState(null);

  // Lock body scroll when modal is open
  useEffect(() => {
    if (selectedService) {
      // Prevent scrolling
      document.body.style.overflow = 'hidden';
    } else {
      // Restore scrolling
      document.body.style.overflow = 'auto';
    }

    // Clean up when the component is unmounted or modal is closed
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [selectedService]);

  return (
    <ScrollReveal>
      <section className="services-section">
        <div className="services-content">
          <div className="services-text">
            <h2>Our Services</h2>
            <p>
              Explore our wide range of services designed to help your business succeed. Our team provides
              high-quality solutions tailored to your needs.
            </p>
            <a href="/services" className="services-button">Explore Services</a>
          </div>

          <LayoutGroup>
            <motion.div className="services-cards" layout>
              {services.map((service) => (
                <motion.div
                  key={service.id}
                  layoutId={`card-container-${service.id}`}
                  className="service-card1"
                  onClick={() => setSelectedService(service)}
                  whileHover={{ 
                    scale: 1.05,
                    y: -5,
                    boxShadow: "0 0 20px 10px rgba(0, 255, 255, 0.5), 0 0 30px 20px rgba(0, 255, 255, 0.4)"
                  }}
                  whileTap={{ scale: 0.95 }}
                  transition={{ type: "spring", stiffness: 300, damping: 20 }}
                  style={{ backgroundImage: `url(${service.image})` }}
                >
                  <motion.h3 layoutId={`card-title-${service.id}`}>{service.title}</motion.h3>
                </motion.div>
              ))}
            </motion.div>

            <AnimatePresence>
              {selectedService && (
                <motion.div
                  className="modal-overlay"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  onClick={() => setSelectedService(null)}
                >
                  <motion.div
                    layoutId={`card-container-${selectedService.id}`}
                    className="service-detail"
                    onClick={(e) => e.stopPropagation()}
                    transition={{ type: "spring", stiffness: 300, damping: 30 }}
                  >
                    <motion.button
                      className="close-button"
                      onClick={() => setSelectedService(null)}
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      exit={{ opacity: 0 }}
                    >
                      ×
                    </motion.button>
                    <motion.img
                      src={selectedService.image}
                      alt={selectedService.title}
                      className="service-detail-image"
                      layoutId={`card-image-${selectedService.id}`}
                    />
                    <motion.div className="service-detail-content">
                      <motion.h3 layoutId={`card-title-${selectedService.id}`}>
                        {selectedService.title}
                      </motion.h3>
                      <motion.p
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                      >
                        Detailed description of {selectedService.title} service goes here.
                      </motion.p>
                      <motion.a
                        href="Services"
                        className="service-detail-button"
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                        transition={{ delay: 0.2 }}
                      >
                        Learn More
                      </motion.a>
                    </motion.div>
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
          </LayoutGroup>
        </div>
      </section>
    </ScrollReveal>
  );
};

export default ServicesSection;
